import { useTranslation } from 'react-i18next';

export type ProductStatus = keyof ReturnType<typeof useProductStatus>;

export const PRODUCT_STATUS = {
    AVAILABLE: 'AVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
};

export const useProductStatus = () => {
    const { t } = useTranslation();
    return { AVAILABLE: t(`STATUS.AVAILABLE`), UNAVAILABLE: t('STATUS.UNAVAILABLE') };
};

export const PRODUCT_STATUS_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    AVAILABLE: 'success',
    UNAVAILABLE: 'error',
};

export const useFilterSelectOptions = () => {
    const productStatus = useProductStatus();

    return Object.keys(productStatus).map((status) => ({
        value: status,
        label: productStatus[status],
    }));
};
